// components/CustomFields/DistributorsField.js
import React, { useEffect, useRef, useState } from "react";
import { dbGet } from "utils/DBFetchers";
import SelectField from "./SelectField";

export default function DistributorsField(props) {
  const [allDistributors, setAllDistributors] = useState([]);
  const requestSeqRef = useRef(0);

  useEffect(() => {
    let isMounted = true;
    const mySeq = ++requestSeqRef.current;

    const run = async () => {
      try {
        let path = "distributors?";
        if (props.only_with_wallet) path += "only_with_wallet=true&";
        if (props.excludePharmacies) path += "exclude_pharmacies=true&";

        const data = await dbGet(path);

        // Si llega tarde una respuesta vieja, la ignoramos
        if (!isMounted || mySeq !== requestSeqRef.current) return;

        let filtered = Array.isArray(data) ? data : [];

        if (props.filterByProgram) {
          const programId = Number(localStorage.getItem("programId"));
          if (!Number.isNaN(programId)) {
            filtered = filtered.filter((d) =>
              d.programs?.some((p) => p.id === programId),
            );
          }
        }

        if (props.program) {
          const pId = Number(props.program);
          filtered = filtered.filter((d) => d.programs?.some((p) => p.id === pId));
        }

        if (props.independents === true) {
          filtered = filtered.filter((d) => d.works_with_independents);
        } else if (props.independents === false) {
          // (mantengo tu lógica: excluir works_with_independents y el id 19)
          filtered = filtered.filter((d) => !d.works_with_independents && d.id !== 19);
        }

        if (props.filterByDistributor) {
          filtered = filtered.filter((d) => d.id !== 19);
        }

        let mapped = filtered.map((item) => ({
          id: item.id,
          name: item.name,
          isAuthoritarian: item.is_authoritarian,
        }));

        if (props.clearable) {
          mapped.unshift({
            id: "",
            name: props.clearText || "— Quitar selección —",
            isAuthoritarian: true,
          });
        }

        if (props.all) {
          mapped.unshift({
            id: -1,
            name: "Todos",
            isAuthoritarian: true,
          });
        }

        setAllDistributors(mapped);
      } catch (e) {
        if (!isMounted || mySeq !== requestSeqRef.current) return;
        setAllDistributors([]);
      }
    };

    run();

    return () => {
      isMounted = false;
    };
    // ⚠️ Dependencias que cambian el resultado
  }, [
    props.only_with_wallet,
    props.excludePharmacies,
    props.filterByProgram,
    props.program,
    props.independents,
    props.filterByDistributor,
    props.clearable,
    props.clearText,
    props.all,
  ]);

  return (
    <SelectField
      fieldClassName={props.fieldClassName}
      id="distributors"
      label="Seleccione Distribuidor"
      name="distributor"
      value={props.value}
      onChange={props.onChange}
      allValues={allDistributors}
      disabled={props.disabled || false}
    />
  );
}
